import {type CSSProperties, type ReactNode, useState} from 'react';
import {AnimatePresence, motion} from 'motion/react';
import {Link} from '../link';
import styles from './dropdown.module.css';

export type Item = {
  text: string;
  href: string;
  color: string;
};

type Props = {
  readonly children: ReactNode;
  readonly data: Item[];
};

export function Dropdown({children, data}: Props) {
  const [show, setShow] = useState(false);

  const toggle = () => {
    setShow((previous) => !previous);
  };

  return (
    <div className={styles.dropdownWrapper}>
      <button type='button' className={styles.button} onClick={toggle}>
        {children}
      </button>
      <AnimatePresence>
        {show && (
          <motion.div className={styles.dropdown} {...motions.slideDown}>
            <ul className={styles.dropdownList}>
              {data.map((item) => (
                <li key={item.text}>
                  <Link
                    isExternal
                    // className={styles.dropdownLink(item.color)}
                    className={styles.dropdownLink}
                    href={item.href}
                    style={
                      {
                        '--custom-bg-color': item.color,
                      } as CSSProperties
                    }
                  >
                    {item.text}
                  </Link>
                </li>
              ))}
            </ul>
          </motion.div>
        )}
      </AnimatePresence>
      {show && <div className={styles.overlay} onClick={toggle} />}
    </div>
  );
}

const motions = {
  slideDown: {
    initial: {
      height: 0,
    },
    animate: {
      height: 'auto',
    },
    exit: {
      height: 0,
    },
    transition: {
      type: 'tween' as const,
      duration: 0.2,
    },
  },
};
